"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableSnapshotConfig = exports.snapshotEndpointIds = exports.sourceTableNames = exports.snapshotNames = void 0;
exports.snapshotNames = {
    main: 'main',
    users: 'users',
    connectedAccounts: 'connectedAccounts',
    statistics: 'statistics',
};
// production table names
// @STAGING: fill table names
exports.sourceTableNames = {
    [exports.snapshotNames.main]: 'dareMeproduction-dareMeProductionApiDynamoDbTable-1LTV7M7W0XP9E',
    [exports.snapshotNames.users]: 'AuthApiProduction-UsersTable9725E9C8-1QHYYFFM429LD',
    [exports.snapshotNames.connectedAccounts]: 'AuthApiProduction-ConnectedAccountsTable8C017390-A50YVJC4PJEO',
    [exports.snapshotNames.statistics]: 'dareMeproduction-dareMeProductionApiDynamoDbStatisticsTable-1KXY6NT97LW6I',
};
exports.snapshotEndpointIds = {
    SAVE_TABLE_SNAPSHOTS: 'SAVE_TABLE_SNAPSHOTS',
};
exports.tableSnapshotConfig = {
    items: [
        {
            name: exports.snapshotNames.main,
            tableName: exports.sourceTableNames.main,
            updateParams: {
                StreamSpecification: {
                    StreamEnabled: true,
                    StreamViewType: 'NEW_IMAGE',
                },
            },
        },
        {
            name: exports.snapshotNames.statistics,
            tableName: exports.sourceTableNames.statistics,
        },
        {
            name: exports.snapshotNames.users,
            tableName: exports.sourceTableNames.users,
        },
        {
            name: exports.snapshotNames.connectedAccounts,
            tableName: exports.sourceTableNames.connectedAccounts,
        },
    ],
};
